function updateQuantityInput(quantity, set = false) {

    try {

        const quantityInput = document.querySelector('.quantity-selector__value');
        if (set) {
            if (quantityInput) {
                quantityInput.value = quantity;
                sliderQuantity = quantity;
                //console.log(quantity);
                let parsedDiscount = parseFloat(checkDiscount(quantity));
                totalPrice = ((quantity * (parsedDiscount + parseFloat(AVPprice)))).toFixed(2);
                totalSavings = (((quantity * (initPrice + parseFloat(AVPprice))) - totalPrice)).toFixed(2);

                //console.log(quantityInput.value, getQuantityInput());

                const formattedTotalPrice = parseFloat(totalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                const formattedTotalSavings = parseFloat(totalSavings).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                //console.log(formattedTotalPrice, formattedTotalSavings);

                totalPriceElement.textContent = '$' + formattedTotalPrice;
                totalSavingsElement.textContent = 'Save $' + formattedTotalSavings;
            }
            return;
        }

        if (quantityInput) {
            console.log(initialQuantity, quantity);
            // Normalize the slider value to a 0-1 range
            const normalizedValue = (quantity - initialQuantity) / (5000 - initialQuantity); // assuming 5000 is the max quantity


            // Apply exponential scaling (adjust the exponent as needed)
            exponent = 4; // Example: exponential factor, can be adjusted
            const scaledValue = (1 / 1.464) * (Math.pow((normalizedValue + 0.1), exponent));

            // Calculate the scaled quantity, ensuring it doesn't go below initQuantity
            const scaledQuantity = Math.round((scaledValue * (5000 - initialQuantity)) + initialQuantity);

            // Update the quantity input with the scaled value
            quantityInput.value = scaledQuantity;
            sliderQuantity = scaledQuantity;

            // Recalculate total price and savings
            let parsedDiscount = parseFloat(checkDiscount(quantity));
            totalPrice = ((scaledQuantity * (parsedDiscount + parseFloat(AVPprice)))).toFixed(2);
            totalSavings = (((scaledQuantity * (initPrice + parseFloat(AVPprice))) - totalPrice)).toFixed(2);

            //console.log(totalPrice, totalSavings);

            // Format the total price and savings
            const formattedTotalPrice = parseFloat(totalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const formattedTotalSavings = parseFloat(totalSavings).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            // Update the display with the formatted values
            totalPriceElement.textContent = '$' + formattedTotalPrice;
            totalSavingsElement.textContent = 'Save $' + formattedTotalSavings;
        }

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}

function getQuantityInput() {

    try {
        const quantityInput = document.querySelector('.quantity-selector__value');
        if (quantityInput) {
            return parseInt(quantityInput.value, 10) || 0;
        }
        return 0;

    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}

function calculatePrecentage() {
    try {
        for (let i = discountRule.length - 1; i >= 0; i--) {
            const discount = discountRule[i];

            let diff = parseFloat(initPrice) * (parseFloat(discount.discount_value) / 100);
            discount.discount_value = (initPrice - diff).toFixed(2);
        }
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}

function checkDiscount(quantity) {
    try {
        // Determine the applicable discount
        let applicableDiscount = initPrice; // Default to original price


        for (let i = discountRule.length - 1; i >= 0; i--) {
            const discount = discountRule[i];
            if (quantity >= parseInt(discount.buy_from)) {
                applicableDiscount = parseFloat(discount.discount_value).toFixed(2);
                break;
            }
        }


        // Apply the discount or reset to the original price
        if (quantity < parseInt(discountRule[0].buy_from)) {
            // Quantity is below the minimum threshold for any discount

            if (typeof resetPrice === 'function') {
                resetPrice();
            }
        } else {


            if (typeof updatePriceAndColor === 'function') {
                updatePriceAndColor(initPrice, applicableDiscount, '#EE0000');
            }

        }

        return applicableDiscount;
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }

}

function getPrice(value) {
    try {
        avpOptions = optionSetTemps[0].options[1];

        const options = avpOptions.option_values;
        const option = options.find(opt => opt.value === value);
        return option ? option.price / 100 : 0; // Convert cents to dollars
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}